import { StyleSheet, Platform } from "react-native";

const styles = StyleSheet.create({
    content: {
        paddingHorizontal: 25,
        marginTop: 20
    },
    hr: {
        height: 2,
        marginTop: 25,
        backgroundColor: "#2C2C2E",
        opacity: 0.5,
    },
    btn: {
        padding: 10,
        borderRadius: 20
    },
    contentItemList: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        marginTop: 25
    },
    initials: {
        padding: 10,
        borderWidth: 3,
        borderColor: "#32BFB1",
        textAlign: 'center',
        textAlignVertical: 'center',
        color: '#32BFB1',
        borderRadius: 10
    },
    infoUser: {
        paddingLeft: 15,
        marginTop: 3
    },
    nameUser: {
        fontSize: 14,
        color: 'rgba(44, 44, 46, 0.8)',
        fontWeight: 'bold'
    },
    emailUser: {
        fontSize: 14,
        color: 'rgba(44, 44, 46, 0.8)',
        fontWeight: '400'
    }
});

export default styles;
